"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var client_1 = require("@apollo/client");
var queries_1 = __importDefault(require("../queries"));
function CategoryLink(_a) {
    var selected = _a.selected, link = _a.link, query = _a.query, children = _a.children;
    var style = selected && selected === link ? { color: '#787878', borderBottom: 'double' } : {};
    var prefetch = function (client) {
        client.query({ query: query });
    };
    return (react_1.default.createElement(client_1.ApolloConsumer, null, function (client) { return (react_1.default.createElement(react_router_dom_1.Link, { to: "/music/".concat(link), style: style, onFocus: function () { return prefetch(client); }, onMouseOver: function () { return prefetch(client); } }, children)); }));
}
function ArtistsLink(_a) {
    var selected = _a.selected, children = _a.children;
    return (react_1.default.createElement(CategoryLink, { selected: selected, link: "artists", query: queries_1.default.topArtists }, children));
}
function AlbumsLink(_a) {
    var selected = _a.selected, children = _a.children;
    return (react_1.default.createElement(CategoryLink, { selected: selected, link: "albums", query: queries_1.default.topAlbums }, children));
}
function TracksLink(_a) {
    var selected = _a.selected, children = _a.children;
    return (react_1.default.createElement(CategoryLink, { selected: selected, link: "tracks", query: queries_1.default.topTracks }, children));
}
exports.default = {
    ArtistsLink: ArtistsLink,
    AlbumsLink: AlbumsLink,
    TracksLink: TracksLink,
};
